
import { Route } from '../../../apps/pu-links/domain/Route'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SearchSummaryBarAction extends Vue {
  @Prop({ default: null })
    searchReferrerRoute: Route | null

  @Prop({ default: false, type: Boolean })
    showEdit: boolean

  @Prop({ default: false, type: Boolean })
    hasDates: boolean

  @Prop({ required: false })
    ptsViewed: number

  backToResults() {
    const stepsToGoBack = this.ptsViewed * 2 + 1
    this.$router.go(-stepsToGoBack)
  }
}
